import { CreditAccountKindCode } from '@/domains/TransferDomain'

import { call } from '../core'

/**
 * IBankInfo
 *
 * bankName: 은행이름
 * bankCode: 은행코드
 * imageUrl: 은행 아이콘 이미지 url
 * accountNumber: 이체 계좌 번호
 * ownerName: 이체 수신자 설정
 * feeAmount: 이체 수수료
 * isLineBank: LINE bank 여부
 */
interface IBankInfo {
  bankName: string
  bankCode: string // BI-Fast: crBicBankCd, Prima: crBnkCd
  imageUrl: string
  accountNumber: string // (schedule transfer register <- BI-Fast: bnfcAcctItmCd, Prima: bnfcAcctNo)
  ownerName: string
  feeAmount: string
  isLineBank: boolean
  accountKindCode?: CreditAccountKindCode // only BI-Fast (only '00-AccountNo' used in hybrid)
  reserved?: string // only BI-Fast
}

export interface IBankInfoResult {
  result: IBankInfo | null
}

export function getBank(): Promise<IBankInfoResult | Error> {
  return call('finGetBank')
}
